import React from "react";
import {
Link
} from "react-router-dom";
import * as firebase from 'firebase/app';
import 'firebase/auth';
import fire from "views/pages/firebaseConfig.js";
import {
withRouter
} from 'react-router-dom';


// reactstrap components
import {
Button,
Collapse,
NavbarBrand,
Navbar,
NavItem,
NavLink,
Nav,
Container,
Row,
Col,
UncontrolledTooltip
} from "reactstrap";



const auth = firebase.auth()

class ComponentsNavbar extends React.Component {

constructor(props) {
super(props);
this.login = this.login.bind(this);
this.handleChange = this.handleChange.bind(this);
this.signup = this.signup.bind(this);
this.logout = this.logout.bind(this);
this.state = {
collapseOpen: false,
color: "navbar-transparent",
user: null,
email: '',
password: ''
};
   
}
logout() {
        
  fire.auth().signOut();
  auth.signOut()
.then(() => {
this.setState({
  user: null
});
});
}
handleChange(e) {
this.setState({
[e.target.name]: e.target.value
});
}
login(e) {
e.preventDefault();
fire.auth().signInWithEmailAndPassword(this.state.email, this.state.password).then((u) => {}).catch((error) => {
console.log(error);
});
}
signup(e) {
e.preventDefault();
fire.auth().createUserWithEmailAndPassword(this.state.email, this.state.password).then((u) => {}).then((u) => {
console.log(u)
})
.catch((error) => {
console.log(error);
})
}
handleLogin() {
var provider = new firebase.auth.FacebookAuthProvider();
firebase
.auth()
.signInWithPopup(provider);
}

handleLogin1() {
var provider = new firebase.auth.GithubAuthProvider();
firebase
.auth()
.signInWithPopup(provider);
}
handleLogin2() {
var provider = new firebase.auth.GoogleAuthProvider();
firebase
.auth()
.signInWithPopup(provider);
}
componentDidMount() {
  window.addEventListener("scroll", this.changeColor);
  auth.onAuthStateChanged((user) => {
    if (user) {
      this.setState({ user });
    } 
  });
}

componentWillUnmount() {
window.removeEventListener("scroll", this.changeColor);
}
changeColor = () => {
if (
document.documentElement.scrollTop > 99 ||
document.body.scrollTop > 99
) {
this.setState({
color: "bg-info"
});
} else if (
document.documentElement.scrollTop < 100 || document.body.scrollTop < 100 ) { this.setState({
  color: "navbar-transparent" }); } }; toggleCollapse=()=> {
  document.documentElement.classList.toggle("nav-open");
  this.setState({
  collapseOpen: !this.state.collapseOpen
  });
  };
  onCollapseExiting = () => {
  this.setState({
  collapseOut: "collapsing-out"
  });
  };
  onCollapseExited = () => {
  this.setState({
  collapseOut: ""
  });
  };
  scrollToDownload = () => {
  document
  .getElementById("download-section")
  .scrollIntoView({
  behavior: "smooth"
  });
  };
  toggleModal = modalState => {
  this.setState({
  [modalState]: !this.state[modalState]
  });
  };

  render() {


  return (
    
  <Navbar className={"fixed-top " + this.state.color}
        color-on-scroll=" 100" expand="lg">
    <Container>
      <div className="navbar-translate">
        <NavbarBrand to="/components" tag={Link} id="navbar-brand">
          <span> NlogN </span>

        </NavbarBrand>
        <UncontrolledTooltip placement="bottom" target="navbar-brand">
          Your One-Stop Destination.
        </UncontrolledTooltip>
        <button aria-expanded={this.state.collapseOpen} className="navbar-toggler navbar-toggler"
          onClick={this.toggleCollapse}>
          <span className="navbar-toggler-bar bar1" />
          <span className="navbar-toggler-bar bar2" />
          <span className="navbar-toggler-bar bar3" />
        </button>
      </div>
      <Collapse className={"justify-content-end " + this.state.collapseOut}
            navbar
            isOpen={this.state.collapseOpen}
            onExiting={this.onCollapseExiting}
            onExited={this.onCollapseExited}
          >
            <div className=" navbar-collapse-header">
        <Row>
          <Col className="collapse-brand" xs="6">
          <a href="#pablo" onClick={e=> e.preventDefault()}>
            NlogN
          </a>
          </Col>
          <Col className="collapse-close text-right" xs="6">
          <button aria-expanded={this.state.collapseOpen} className="navbar-toggler" onClick={this.toggleCollapse}>
            <i className="tim-icons icon-simple-remove" />
          </button>
          </Col>
        </Row>
        </div>
        
        <Nav navbar>

          <NavItem>
            <Button className="nav-link d-none d-lg-block" color="default" target="_blank"
              href="https://www.creative-tim.com/product/blk-design-system-pro-react?ref=bdsr-user-archive-index-navbar-upgrade-pro">
              <i className="tim-icons icon-spaceship" />
              <NavLink to="/login" tag={Link}>
                Competitive
              </NavLink>
            </Button>
          </NavItem>
          <NavItem>
            <Button className="nav-link d-none d-lg-block" color="default" target="_blank"
              href="https://www.creative-tim.com/product/blk-design-system-pro-react?ref=bdsr-user-archive-index-navbar-upgrade-pro">
              <i className="tim-icons icon-spaceship" />
              <NavLink to="/login" tag={Link}>
                Development
              </NavLink>
            </Button>
          </NavItem>
          <NavItem>
            <Button className="nav-link d-none d-lg-block" color="default" target="_blank">
              <i className="tim-icons icon-spaceship" />
              <NavLink to="/login" tag={Link}>
                Interview Corner
              </NavLink>
            </Button>
          </NavItem>
          <NavItem>
          {this.state.user ?
        <NavItem>
        <Button className="nav-link d-none d-lg-block" color="warning" onClick={this.logout}>
          <NavLink to="/app" tag={Link}>
          Sign-Out Now
          </NavLink>

        </Button>  
        {}

          </NavItem>             
    :
    <NavItem>
    <Button className="nav-link d-none d-lg-block" color="warning">
      <NavLink to="/app" tag={Link}>
      Sign-In Now
      </NavLink>

    </Button>  
    {}

      </NavItem>              
        }

            
            {}

          </NavItem>
          <NavItem className="p-0">
            <NavLink data-placement="bottom" href="https://twitter.com/Aditya__50" rel="noopener noreferrer"
              target="_blank" title="Follow us on Twitter">
              <i className="fab fa-twitter" />
              <p className="d-lg-none d-xl-none">Twitter</p>
            </NavLink>
          </NavItem>
          <NavItem className="p-0">
            <NavLink data-placement="bottom" href="https://www.facebook.com/profile.php?id=100004027149043" rel="noopener noreferrer"
              target="_blank" title="Like us on Facebook">
              <i className="fab fa-facebook-square" />
              <p className="d-lg-none d-xl-none">Facebook</p>
            </NavLink>
          </NavItem>
          <NavItem className="p-0">
            <NavLink data-placement="bottom" href="https://www.instagram.com/"
              rel="noopener noreferrer" target="_blank" title="Follow us on Instagram">
              <i className="fab fa-instagram" />
              <p className="d-lg-none d-xl-none">Instagram</p>
            </NavLink>
          </NavItem>
        </Nav>
      </Collapse>
    </Container>
  </Navbar>
  );

  }
  }

  export default withRouter(ComponentsNavbar);